function resetPassword() {
	var background = $("#reset-password-bg");
	var submitButton = $("#submit-button");
	var secondStep = $("#reset-password-second-modal");
	var secondStepForm = $("#reset-password-second");
	var success = $("#reset-password-success");
	var error = $("#reset-password-error");
	var samePasswordMsg = $("#same-password-msg");
	var parameters = getUrlParameters();

	if (secondStepForm.length > 0) {
		checkTokenAndId();
	}

	secondStepForm.on("submit", function (e) {
		console.log("SUB");
		e.preventDefault();
		submitButton.prop("disabled", true);
		$("#reset-password-second input[name=token]").val(parameters.token);
		$("#reset-password-second input[name=userId]").val(parameters.userId);
		var formData = secondStepForm.serialize();
		$.ajax({
			type: "POST",
			url: apiPath + "changePassword",
			data: formData,
			success: function () {
				submitButton.prop("disabled", false);
				hideModal(secondStep);
				showModal(success);
			},
			error: function (data) {
				submitButton.prop("disabled", false);
				if (
					data.responseText &&
					data.responseText.indexOf("the same password") > -1
				) {
					samePasswordMsg.removeClass("hidden");
				} else {
					hideModal(secondStep);
					showModal(error);
				}
			}
		});
	});

	function checkTokenAndId() {
		var formData = "token=" + parameters.token + "&userId=" + parameters.userId;
		$.ajax({
			url: apiPath + "/changePassword",
			type: "GET",
			data: formData,
			success: function (data) {
				if (data.message == "success") {
					showModal(secondStep);
				} else {
					showModal(error);
				}
			},
			error: function () {
				showModal(error);
			}
		});
	}

	function showModal(modal) {
		background.show();
		modal.removeClass("hidden");
	}

	function hideModal(modal) {
		background.show();
		modal.addClass("hidden");
	}
}
